import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import RoleBadge from '../../../components/ui/RoleBadge';

const AnnouncementCard = ({ announcement }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const getPriorityColor = (priority) => {
    switch (priority) {
      case 'high':
        return 'text-error';
      case 'medium':
        return 'text-warning';
      default:
        return 'text-muted-foreground';
    }
  };

  const formatTimestamp = (date) => {
    const now = new Date();
    const diff = now - date;
    const hours = Math.floor(diff / (1000 * 60 * 60));
    const days = Math.floor(hours / 24);

    if (days > 0) return `${days}d ago`;
    if (hours > 0) return `${hours}h ago`;
    return 'Just now';
  };

  return (
    <div className={`card transition-base ${!announcement?.isRead ? 'border-l-4 border-l-primary' : ''}`}>
      <div className="flex items-start justify-between gap-4 mb-4">
        <div className="flex items-center gap-3 flex-1 min-w-0">
          <div className="character-avatar flex-shrink-0">
            {announcement?.authorAvatar}
          </div>
          <div className="flex-1 min-w-0">
            <div className="flex items-center gap-2 flex-wrap">
              <h3 className="text-base md:text-lg font-semibold text-foreground truncate">
                {announcement?.title}
              </h3>
              {!announcement?.isRead && (
                <span className="inline-flex items-center px-2 py-1 rounded-md bg-primary text-primary-foreground text-xs font-medium flex-shrink-0">
                  New
                </span>
              )}
            </div>
            <div className="flex items-center gap-2 mt-1 flex-wrap">
              <span className="text-sm text-foreground font-medium">{announcement?.author}</span>
              <RoleBadge role="officer" />
              <span className="text-xs text-muted-foreground">{formatTimestamp(announcement?.timestamp)}</span>
            </div>
          </div>
        </div>
        <div className="flex items-center gap-2 flex-shrink-0">
          <Icon 
            name={announcement?.priority === 'high' ? 'AlertCircle' : announcement?.priority === 'medium' ? 'Info' : 'MessageSquare'} 
            size={20} 
            className={getPriorityColor(announcement?.priority)}
          />
        </div>
      </div>
      <div className={`text-sm md:text-base text-foreground ${!isExpanded ? 'line-clamp-3' : ''}`}>
        {announcement?.content}
      </div>
      {announcement?.content?.length > 150 && (
        <button
          onClick={() => setIsExpanded(!isExpanded)}
          className="mt-3 text-sm font-medium text-primary hover:text-accent transition-base flex items-center gap-1"
        >
          {isExpanded ? 'Show less' : 'Read more'}
          <Icon name={isExpanded ? 'ChevronUp' : 'ChevronDown'} size={16} />
        </button>
      )}
      {announcement?.tags && announcement?.tags?.length > 0 && (
        <div className="flex items-center gap-2 mt-4 flex-wrap">
          {announcement?.tags?.map((tag, index) => (
            <span
              key={index}
              className="inline-flex items-center px-3 py-1 rounded-md bg-muted text-muted-foreground text-xs font-medium"
            >
              {tag}
            </span>
          ))}
        </div>
      )}
    </div>
  );
};

export default AnnouncementCard;